export const permissions = {
  canUpdateBrewery: 'canUpdateBrewery',
  canCompleteLot: 'canCompleteLot'
};



// WEBPACK FOOTER //
// ./src/utils/permissions.js